export const getOriginalValues = data => ({
  item_name: data.get('item_name'),
  amount: data.get('amount'),
  currency_code: data.get('currency_code'),
  item_number: data.get('item_number'),
  shipping: data.get('shipping')
})
